import React, {useRef} from "react";
import {Map, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react';
import Footer from "../Common/Footer/Footer";
import { withRouter } from 'react-router';

import Tabletop from "tabletop";
import Header from "../../views/Common/Header/Header";
import {config} from '../../constants/Constants'
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Autocomplete from '@material-ui/lab/Autocomplete';
import marker from '../../assets/images/marker.png';
import Parking from '../../assets/images/parking.png';
import axios from 'axios'
import Papa from 'papaparse'

export class Search extends React.Component{     
    constructor(props){
        super(props);
        this.state = {
            activeMarker: {},
            selectedPlace: {},
            showingInfoWindow: false,
            locations : [
                { title: 'Quebec'},
            ],
            literals : {},
            lots : [],
            displayLang : localStorage.getItem("displayLang"),
            scrollRef : React.createRef(),
            appLink:""
        }
    }

    componentDidUpdate(prevProp, prevState){
    }

    componentDidMount() { 
        this.getSheetData();
    }

    getSheetData(){
        let literal = JSON.parse(localStorage.getItem("literals"));                
        let selectLang = localStorage.getItem("displayLang");
        if(JSON.parse(localStorage.getItem("lots") !== null)){
            let lots = JSON.parse(localStorage.getItem("lots")); 
            this.setState({lots : lots});           
        }
        if(literal !== null){
            this.setState({literals : literal});           
            this.setState({displayLang : selectLang});   
        }
        if(selectLang == null){ 
            selectLang = navigator.language || navigator.userLanguage; 
            selectLang = selectLang.split('-')[0]
            this.setState({displayLang : selectLang});              
        }
        // axios.get(config.url.spreadSheet + "Literals").then((res)=>{
        //     let result = this.mapLanguages(selectLang, res.data);            
        //     this.setState({
        //         literals : result,
        //         literalsData : res.data
        //     }) 
        // })
        // axios.get(config.url.spreadSheet + "Lots").then((res)=>{
        //     this.setState({
        //         lots : res.data,
        //     }) 
        // })
        Papa.parse(config.url.spreadSheet + "pub?gid=1443882505&output=csv", {
            download: true,
            header: true,
            complete: (res) => {
                let result = this.mapLanguages(selectLang, res.data);            
                this.setState({
                    literals : result,
                    literalsData : res.data
                })
            },
        });
        Papa.parse(config.url.spreadSheet + "pub?gid=527077082&output=csv", {
            download: true,
            header: true,
            complete: (res) => {
                console.log(res.data)
                this.setState({
                    lots : res.data,
                })
            },
        });
    }
    mapLanguages(language, languageData){           
        let languageArray = {};
        if(language == 'fr'){            
            this.setState({displayLang : 'fr'});
            localStorage.setItem("displayLang", 'fr')
        }else if(language == 'en'){            
            this.setState({displayLang : 'en'});
            localStorage.setItem("displayLang", 'en')
        } 
        languageData.forEach((item)=>{                          
            languageArray[item.key] = item[language];            
        })
        localStorage.setItem('literals', JSON.stringify(languageArray))
        return languageArray;
    }

    selectedLanguage(e){         
        this.setState({displayLang : e});
        let result = this.mapLanguages(e,this.state.literalsData);
        this.setState({literals : result});
        window.location.reload();
    }

    more(id,item){
        let data = this.state.lots
        data.forEach(function (element) {
            element.Active = "false";
          });
        this.setState({ lots: data });
        data[id].Active = 'true'
        this.setState({ lots: data });
    }

    less(id,item){
        // console.log(id,item)
        let data = this.state.lots
        data[id].Active = 'false'
        this.setState({ lots: data });
    }

    onMarkerClick(ref){
        console.log(ref,this.state.scrollRef);   
        const violation = document.getElementById(ref);
        const scrollDiv = document.getElementById("scrollDiv");
        const yOffset = -70; 
        const y = violation.offsetTop + yOffset;
        scrollDiv.scrollTo({
            top:y,
            behavior:"smooth"
        });
        if(this.mobileCheck()){
            window.scrollTo({
                top:scrollDiv.offsetTop + 490,
                behavior:"smooth"
            });   
        }
    }

    onInfoWindowClose = () =>
        this.setState({
        activeMarker: null,
        showingInfoWindow: false
        });
    onMapClicked = () => {
        if (this.state.showingInfoWindow)
            this.setState({
            activeMarker: null,
            showingInfoWindow: false
            });
        };
    contact(list){
        console.log(list['Parking URL'])

        // let rate;
        // let type;
        //  if(this.state.displayLang == 'en'){
        //     rate = list['Rate en']
        //     type = list['Lot Type']
        //  }else{
        //     rate = list['Rate fr']
        //     type = list['Lot Type fr']
        //  }     
        // // this.props.history.push({
        // //     pathname: '/contact-us?lot-name='+lotname
        // //   })
        // this.props.history.push('/contact-us?lot-name='+list['Lot Name']+'&lot-type='+type+'&rate='+rate)
    }
    onZoneSelected(coord){
        this.props.selectedZone(coord);
        if(this.mobileCheck()){
            const scrollDiv = document.getElementById("mapDiv");
            window.scrollTo({
                top:scrollDiv.offsetTop,
                behavior:"smooth"
            });   
        }
    }

    mobileCheck() {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    };
    
    render() {        

    return(
            <> 
                <Header
                    displayLang = {this.state.displayLang}                    
                    literals = {this.state.literals}
                    
                    selectedLanguage = {(e) => {this.selectedLanguage(e)}}
                /> 
                <div className="main-container">
                    <div className="row">                            
                        <div className="col-md-6 col-lg-6 p-0" style={{ height:'80vh'}} id="mapDiv">
                            {this.state.lots.length > 0 && <div className="map-frame">
                                <Map 
                                    google={this.props.google} 
                                    zoom={this.props.zoom}                       
                                    onClick={this.onMapClicked}                                    
                                    initialCenter={
                                        this.props.currentPosition
                                    }
                                    center= {this.props.currentPosition}
                                >   
                                    <InfoWindow
                                        marker={this.state.activeMarker}
                                        onClose={this.onInfoWindowClose}
                                        visible={this.state.showingInfoWindow}
                                        >
                                        <div>
                                            <h4>{this.state.selectedPlace.name}</h4>
                                        </div>
                                    </InfoWindow>
                                    {this.state.lots.map((x)=>{
                                        return(
                                            <Marker                                         
                                                onClick={()=>this.onMarkerClick("ref"+x.Seq)}
                                                icon={{url: marker, scaledSize: new this.props.google.maps.Size(40,40)}}
                                                position={{lat:x.Latitude, lng:x.Longitude}}
                                                label= {{ color: '#fff', fontWeight: 'bold', fontSize: '20px', text: x.Seq }}
                                            />
                                        )
                                    })}
                                    {/* <Marker 
                                        position={this.props.currentPosition}
                                        icon="https://www.robotwoods.com/dev/misc/bluecircle.png"
                                    />                                     */}
                                </Map>
                            </div>}
                        </div>                                
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <div className="locationBtn">
                                <button type="button" onClick={this.props.getGeoLocation} className="btn rounded-pill btn-primary">
                                    {this.state.literals.useMyLocation}
                                </button>
                            </div>
                            <div className="search-card" id="scrollDiv">                                        
                            {this.state.lots.map((x,index)=>{ 
                                // let image = "https://drive.google.com/thumbnail?id="+x.Image
                                let image = `https://drive.google.com/thumbnail?id=${x.Image}`
                                return(
                                <Card id={"ref"+x.Seq}>
                                    <CardContent>
                                        <div className="row" >
                                            <div className="col-sm-12 col-md-12 col-lg-5">
                                                <img width='100%' src={image}/>
                                            </div>
                                            <div className="col-sm-12 col-md-12 col-lg-7">
                                                <h4 className="text-green" style={{cursor:'pointer'}} onClick={(e)=>this.onZoneSelected({lat:x.Latitude, lng:x.Longitude})}>{x['Lot Name']} ({x.Seq})</h4>
                                                <h5 className="text-blue">
                                                    {this.state.displayLang == 'en' ? 
                                                        x['Lot Type'] : x['Lot Type fr']
                                                    }                                                            
                                                </h5>
                                                <p className="text-blue">{x['Owner']}</p>
                                                <span className="location"><b>{x['Location']}</b></span><br/>
                                                <p className="desc">
                                                {/* {x.Active == 'true' ? */}
                                                    {this.state.displayLang == 'en' ? 
                                                    x['Rate en'] : x['Rate fr']
                                                    }
                                                {/* // } */}
                                                </p>
                                                <br/>
                                                <div className="contactBtn">
                                                    <a href={x['Parking URL']} target="_blank" rel="noreferrer">
                                                        <button type="button" class="locBtn">
                                                            {this.state.literals.parkNow}                                                            
                                                        </button><br/>
                                                    </a>
                                                    {/* <button type="button" class="locBtn" onClick={(e) => {this.contact(x)}}>
                                                        {this.state.literals.contact}                                                            
                                                    </button><br/> */}
                                                </div>
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>
                                )
                            })} 
                            </div>                                                                                                       
                        </div>
                    </div>                    
                </div>
                <div className="container quiest">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-md-5">
                            <h5 className="text-gray">{this.state.literals.whoIs}</h5>
                            <h1 className="text-green" style={{fontSize: "50px"}}>PARK 45 ?</h1>
                            <p>
                                {this.state.literals.para1}
                            </p>
                            {/* <button className="btn btn-blue text-white">
                                {this.state.literals.JoinUsToday}
                            </button> */}
                        </div>
                        <div className="col-md-7">
                            <img width="100%" style={{marginTop: "20px"}} src = {Parking}/>
                        </div>
                    </div>
                </div>
                <Footer
                    literals = {this.state.literals}                
                />
            </>
        )
    }
}

export default GoogleApiWrapper({
apiKey: config.url.googleKey
})(Search);